import React from 'react'
import { useState,useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useQuery } from '@apollo/client';
import {ShippingProfilesList} from "../pages/shipping-profiles/operations.graphql"
import {startLoading,stopLoading} from "../actions/shipping";

export default function useShippingProfilesList() {
   const dispatch = useDispatch();
    const { data, loading, error, refetch,fetchMore,...rest } = useQuery(ShippingProfilesList, {
        variables: { first: 30 },
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first',
      });
      const [isRefetching, setIsRefetching] = useState(false);//no pratical use, just in case
        const [isFetchingMore, setIsFetchingMore] = useState(false);//no pratical use, just in case
  
      // fetchMore
  const refetchWithTracking = async () => {
    setIsRefetching(true);
    dispatch(startLoading())
    console.log('refetching...start...')
    try {
    //  await new Promise(resolve => setTimeout(resolve, 5000));//todo 上线前注释掉，模拟refetching花了5秒
      await refetch();
    } finally {
      setIsRefetching(false);
     console.log('refetching...end...')
     dispatch(stopLoading())
    }
  };


  // fetchMore with tracking
  const fetchMoreWithTracking = async (options,cb) => {
    setIsFetchingMore(true);
    console.log('fetchMore...start...')
    try {
      // await new Promise(resolve => setTimeout(resolve, 3000)); // 模拟fetchMore花了3秒
      return await fetchMore(options);
    } finally {
      setIsFetchingMore(false);
      console.log('fetchMore...end...')
      cb()
    }
  };

  return {shippingProfilesList:{ data, loading, error, 
    refetch: refetchWithTracking, 
    fetchMore: fetchMoreWithTracking, 
    isFetchingMore,
    isRefetching,...rest }}
}
